import { factory, random, sequence } from 'stahlwerk';

export const createDurationBalance = factory({
  date: '2000-01-01',
  crewId: sequence(),
  value: random((rand) => `PT${Math.floor(rand * 3660)}S`),
  groupBy: {},
});
